module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062847355_Contents#r_idParaDest-10"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("Jax")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He would never forgive himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Turn around!” Robb cried, trying to grab the controls, but Jax shoved him back into his seat. The desperation on his face made Jax’s stomach twist. “We’re not leaving her! We have to turn back! We—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We "), _c('i', [_vm._v("can’t")]), _vm._v(",” Jax snapped, and Goddess’s spark he hated saying those words. He hated that his tongue did not curl with the taste of a lie. It was the truth in the worst possible way, and he hated himself more that he was the one who had to turn the skysailer away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have to! Ana is back there! If he gets to her—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, "), _c('i', [_vm._v("ma’alor")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why aren’t we turning back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because we’ll be caught, too.” He curled his fingers tighter around the controls. This was a choice that wasn’t his to make.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ana had told him back on the "), _c('i', [_vm._v("Dossier")]), _vm._v(" that if anything went south, save Starbright. She had pulled him behind the skysailer in the cargo bay before they’d gone down to Neon City, while "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("Robb had been tweaking his new mechanical arm.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jax had hissed, “Ana, you’re more important—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not right now I’m not,” she had said. “Starbright is more important.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t promise that—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, Jax,” she had pleaded, a little quieter. “If Starbright can bring a Metal out of the HIVE . . . we’ll be one step closer to "), _c('i', [_vm._v("stopping")]), _vm._v(" the HIVE. With Starbright, we’ll have a better chance at saving our kingdom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not without you we can’t,” Jax had tried to point out, but it was no use. He knew that defiant set of her lips. He couldn’t dissuade her. Besides, he had already seen how this exact excursion was going to go. He had seen it months ago when he had kissed Robb in the quiet of the medical bay, after the fight that took Robb’s arm. He hadn’t even been thinking when he pressed his mouth to Robb’s, and the fates had swirled inside his head again. The images haunted his dreams, burned into the backs of his eyelids—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("A building like a shard of black glass. A rusted cell. The Royal Captain. Di but not Di in a dimly lit control room. A skysailer too far away. A window of crackling glass. And then—")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the backseat, the girl with silver hair—Starbright? Who knew—said, “Ah, fellas, is that thing supposed to be blinking?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A flashing red message sprang up on the windshield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("RETURN OR RESIST ARREST")]), _vm._v(", it warned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, this was just becoming so much "), _c('i', [_vm._v("fun")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He swiped the warning away. “Robb, how did they ping us? We’re cloaked.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("“They’re not supposed to be able to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the rearview mirror, a skysailer swirled down from the night sky to follow them. Its wings were a metallic blue. Jax tightened his grip on the helm. “Well, "), _c('i', [_vm._v("now")]), _vm._v(" they’re following.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They must’ve decoded our cloaking signal.” Robb bent forward underneath the dash and slammed his hand against a door. It popped open to reveal the skysailer’s onboard terminal. As he worked to input a new code into the keypad, three fingers on his mechanical hand suddenly went limp. “Goddess’s "), _c('i', [_vm._v("tits")]), _vm._v(",” he swore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Less cursing, more cloaking, "), _c('i', [_vm._v("ma’alor")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to see "), _c('i', [_vm._v("you")]), _vm._v(" try when your arm isn’t cooperating—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you’re doing it "), _c('i', [_vm._v("wrong")]), _vm._v(" anyway"), _c('i', [_vm._v(".")]), _vm._v(" Get out of my way!” added the girl, climbing into the front seat and diving for the onboard terminal underneath the dash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The skysailer behind them crept closer. It was sleek and silver, its fanlike wings angled back to help the ship gain speed, with a Messier at the helm. Jax hated trying to outrun androids. They didn’t make nearly as many mistakes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Sparkles, can you buy us time?” the girl shouted at him from the floorboards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Sparkles")]), _vm._v(". There could be worse nicknames. “How long?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As much time as you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I have to keep steady or—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She extracted herself from underneath the dash long enough to give him a dead-serious look. “I could work doing a barrel roll while riding bareback on a jetcycle. I am nothing if not a professional.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jax suddenly liked Starbright a little better. “Understood. Robb, buckle up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("His partner began to pale. “Please no barrel r—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reached over and pulled Robb’s harness tight across his chest. “Hang on to her,” he said, and Robb clamped his arms around one of the hacker’s legs a moment before Jax cut the skysailer to the left. Everything in the ship—the loose change, repair tools, trash—went sliding across the floorboards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ship twirled, rolling over on itself, and shot toward the heart of Neon City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Oy!”")]), _vm._v(" Starbright squeaked. “Watch the hand!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mortified, Robb jerked his mechanical hand away from her rear. “A-apologies!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jax banked a hard left as he passed a tall glass building, curving around it, and cut between two traffic lines. Warning sirens blared as he barely missed a commercial vehicle and skimmed over the crowded streets below. People in ponchos and damp capes looked up as they swirled past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The silver skysailer followed swiftly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From afar, Neon City looked like a mountain of glass buildings covered in neon lights, the mist surrounding it making it glow like some otherworldly haven. It would be a fun place if it weren’t for the smell of dampness and smoke and poverty that permeated the streets. Most of its residents got by illegally—selling black-market wares, or living off cheated winnings from the gambling rings beneath the city itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every time he flew one way, the Messier skysailer would match him. He couldn’t shake the stupid craft no matter what he did. He could keep dodging in and out of buildings all day long, but he was more afraid of the Messier ship calling for backup.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("“Are you done yet?” he shouted at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gimme a "), _c('i', [_vm._v("sec")]), _vm._v("!” she cried. “I’m not the Goddess here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The skysailer began to whine as it overheated, its trail of white vapors growing increasingly gray. And still the silver Messier skysailer had no problem following.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If that’s how the HIVE wanted to play, he’d play.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Goddess grant me a steady hand—and please ignore")]), _vm._v(" ma’alor"), _c('i', [_vm._v("’s luck")]), _vm._v(", he added as he drove the skysailer into the sky again and cut toward a cluster of buildings that stood so closely together it looked like nothing could squeeze between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robb looked up long enough to see exactly where they were heading.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jax,” he warned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He eased himself back and loosened his grip on the controls. The buildings came closer. They were commercial high-rises. Ironblood-owned—Malachite, it seemed. Or maybe Obsidia. Whoever it was, he hoped they had insurance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jax, don’t—Jax—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Closer. Closer still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“JAX—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tapped the controls, and the skysailer tilted onto its side and eased through a crack between the buildings. One moment there was sky, and the next there was steel and glass, and they were between them. The silver skysailer tried to bank up, but it was too late. It exploded into the glass tower, sending shrapnel spiraling down into the city center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("As they swirled out on the other side of the buildings, Jax glanced behind him one last time to make sure they were gone, then pumped his fist into the air. “And "), _c('i', [_vm._v("boom")]), _vm._v("!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In reply, Robb let go of the hacker’s legs, his face so pale he looked like a corpse. “I’m going to puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Metal, still perched in the backseat, one leg crossed over the other, applauded. “There was only a twenty-three-point-four percent chance of us surviving that. Congratulations, we are alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For "), _c('i', [_vm._v("now")]), _vm._v(",” replied the hacker, who tapped Robb to help pull her up from the floorboards and back into her seat. She flipped back her shoulder-length hair, and Jax noticed that she was Solani as well, though she must have had hints of Erosian blood. She gave a start when she saw Jax—they’d barely glanced at each other when she first fell into the skysailer—and his skin prickled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hadn’t recognized him, had she?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If she did, she didn’t mention it. Maybe that was worse. “That signal should keep us cloaked for at least twenty minutes, but I’ll say fifteen just to be safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To do what?” Robb asked. “Ana’s "), _c('i', [_vm._v("gone")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the rearview mirror, he watched as a silent conversation passed between the girl and the Metal, and then she nodded and reached into the Metal’s dark bag. She pulled out a holo-pad, her fingers moving quickly across the glass. “Not quite. I slipped a tracker underneath her coat collar. No one ever looks there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jax turned around in the seat to give her a weary look. “Why would you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("“So . . . I could find her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robb blinked. “Who "), _c('i', [_vm._v("are")]), _vm._v(" you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without even looking up from her holo-screen, she waved to her Metal friend. “This is Xu, my partner, and I’m Elara Vath’aka.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Vath’aka")]), _vm._v("—a name given to Solani with no birthright. Her family had been exiled, then—either her parents, or grandparents, or great-grandparents before that. The little knot of tension that had solidified in his chest began to unravel, because if she was born without a birthright, she had probably never visited Zenteli. Which meant she "), _c('i', [_vm._v("wouldn’t")]), _vm._v(" have recognized him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t know he was the C’zar"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The HIVE has her in a skysailer already. Taking her off-world and onto one of those dreadnoughts the Emperor recommissioned, if I’d hazard a guess. And that’s not good. If those rumors are true . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They can’t be,” Jax said, pulling at his gloves nervously. “Only Rasovant knew how to make people into Metals. It’s just a rumor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what if someone else figured it out?” wondered Xu.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was something Jax definitely didn’t want to think about. “We should save her either way—as quickly as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robb gave him a solid look and dipped his head in to say quietly so only Jax could hear, “"), _c('i', [_vm._v("Ma’alor")]), _vm._v(", I don’t trust them. It seems so fortuitous. How did they know to contact us? That we were looking to stop the HIVE? It’s too easy. We should make them promise on iron and stars to help us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like how Jax had made Robb’s mother promise on iron and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("stars to keep Robb safe, and so she stepped in front of a bullet meant for him. Jax had never mustered up the courage to tell Robb—and whether or not it had any hand in her death, he felt ashamed anyway. To hear Robb ask to make this girl and the Metal promise, it made his skin prickle. He wouldn’t let Robb make the same mistake he had.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not going to do that,” he replied sternly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robb narrowed his eyes, but when Jax refused to relent, he looked away with a huff. “Well, I’m not telling Siege.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will tell this Siege,” the Metal said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the rearview mirror, Jax watched Elara quirk an eyebrow at her partner. “Don’t pretend like you don’t know who Captain Siege is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is probably quite lovely, Elara.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jax programmed the coordinates to the dreadnought into the guidance system of the skysailer and banked up out of the atmosphere and into the star-filled sky.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4975a5d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062847355_Chapter_5.vue
// module id = 87
// module chunks = 0